module.exports = __webpack_public_path__ + "img/8faa3e2.webp";